module.exports = __webpack_public_path__ + "img/number_down.3c6f7ad6.svg";